import React from "react";
import Layout from "@app/Layout";
import Canonical from "@shared/head/Canonical";
import Breadcrumbs from "@shared/head/Breadcrumbs";

import Hero from "@features/pop-ups-common/Hero";
import Steps from "@features/pop-ups-common/Steps";
import Demo from "@features/pop-ups-common/Demo";
import Tiles from "@features/pop-ups-common/Tiles";
import CtaBanner from "@features/pop-ups-common/CtaBanner";
import Cases from "@features/pop-ups-common/Cases";
import Advantages from "@features/pop-ups-common/Advantages";
import FAQ from "@features/pop-ups-common/FAQ";
import FinalCTA from "@features/pop-ups-common/FinalCTA";

import {
  heroData,
  stepsData,
  scenariosData,
  casesHeading,
  advantagesData,
  faqData,
  finalCtaData,
} from "@shared/arrays/pop-ups-software";

export const Head = () => (
  <>
    <title>Pop-up Software: Build Website Pop-ups Without Code | Dashly</title>
    <meta
      name="description"
      content="Dashly pop-up software turns website traffic into leads. Design the pop-up, choose the time, the audience and the pages, then A/B test it. No coding skills needed."
    />
    <Canonical url="https://www.dashly.io/pop-ups/pop-up-software/" />
    <Breadcrumbs
      list={[
        { name: "Dashly", url: "https://www.dashly.io/" },
        { name: "Pop-ups", url: "https://www.dashly.io/pop-ups/" },
        {
          name: "Pop-up software",
          url: "https://www.dashly.io/pop-ups/pop-up-software/",
        },
      ]}
    />
  </>
);

export default function PopUpSoftwarePage({
  location,
}: {
  location: Location;
}) {
  return (
    <Layout location={location} className="new-design ds-2026">
      <Hero
        title={
          <>
            Pop-up software that turns traffic into <em>leads</em>
          </>
        }
        {...heroData}
      />

      <Steps
        title={stepsData.title}
        lead={stepsData.lead}
        intro={stepsData.intro}
        steps={stepsData.steps}
      >
        <Demo
          src={stepsData.video}
          poster={stepsData.poster}
          label={stepsData.videoAlt}
        />
      </Steps>

      <CtaBanner />

      <Tiles
        title={scenariosData.title}
        lead={scenariosData.lead}
        intro={scenariosData.intro}
        items={scenariosData.items}
      />

      <Cases title={casesHeading.title} lead={casesHeading.lead} />

      <Advantages
        title={advantagesData.title}
        lead={advantagesData.lead}
        intro={advantagesData.intro}
        items={advantagesData.items}
      />

      <FAQ title={faqData.title} items={faqData.items} />

      <FinalCTA {...finalCtaData} />
    </Layout>
  );
}
